import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults, sizes } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var widthMap = {
  large: '13px',
  default: '9px',
  small: '7px',
  mini: '5px'
};
export var types = ['primary', 'warning', 'danger', 'success'];
var typeStyles = types.reduce(function (memo, type) {
  var color = theme.color;
  memo[type] = {
    get color() {
      return color[type];
    }
  };
  return memo;
}, {});
var sizeStyles = sizes.reduce(function (memo, size) {
  var styles = theme[size];
  memo[size] = {
    get width() {
      return widthMap[size];
    }
  };
  return memo;
}, {});
var defaults = deepDefaults({
  fontSize: '12px',
  padding: '0 0 16px 24px',
  get lineBorder() {
    return "1px solid " + theme.color.border;
  },
  indicator: {
    width: '16px'
  }
}, typeStyles, sizeStyles);
var timeline;
setDefault(function () {
  timeline = deepDefaults(theme, {
    timeline: defaults
  }).timeline;
  makeStyles == null || makeStyles.clearCache();
  makeItemStyles == null || makeItemStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("font-size:", timeline.fontSize, ";padding-top:calc(", theme.lineHeight, "em / 2);");
});
export var makeItemStyles = cache(function makeItemStyles(k) {
  return /*#__PURE__*/css("position:relative;padding:", timeline.padding, ";.", k, "-timeline-indicator{width:", timeline.indicator.width, ";position:absolute;left:0;top:0;height:100%;text-align:center;}.", k, "-timeline-dot{position:relative;z-index:1;transform:translateY(-50%);}.", k, "-timeline-circle{position:relative;background:", theme.color.primary, ";border-radius:50%;left:50%;}.", k, "-timeline-line{position:absolute;height:100%;border-left:", timeline.lineBorder, ";top:0;left:50%;}.", k, "-timeline-content{position:relative;top:calc(-0.5 * ", theme.lineHeight, "em);}&:last-of-type{.", k, "-timeline-line{display:none;}}", _mapInstanceProperty(types).call(types, function (type) {
    var typeStyles = timeline[type];
    return /*#__PURE__*/css("&.", k, "-", type, "{.", k, "-timeline-indicator{color:", typeStyles.color, ";}.", k, "-timeline-circle{background:", typeStyles.color, ";}}");
  }), _mapInstanceProperty(sizes).call(sizes, function (size) {
    var styles = timeline[size];
    var sizeClassName = /*#__PURE__*/css(".", k, "-timeline-circle{width:", styles.width, ";height:", styles.width, ";margin-left:calc(-0.5 * ", styles.width, ");}");
    if (size === 'default') return sizeClassName;
    return /*#__PURE__*/css("&.", k, "-", size, "{", sizeClassName, ";}");
  }), ";");
});